<footer class="group js-footer" id="footer" role="contentinfo">
  <div class="footer-wrapper">
    <div class="footer-meta">
      <div class="footer-meta-inner">
        <h2 class="visuallyhidden">Support links</h2>
        <ul>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a target="_blank" routerLink="/accessibility-statement">Accessibility Statement</a></li>
          <li>Built by the <a href="https://www.gov.uk/government/organisations/standards-and-testing-agency">Standards and Testing Agency</a></li>
        </ul>
        <div class="open-government-licence">
          <p class="logo"><a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" rel="license">Open Government Licence</a></p>
          <p>All content is available under the <a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" rel="license">Open Government Licence v3.0</a>, except where otherwise stated</p>
        </div>
      </div>
      <div class="copyright">
        <a href="http://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/copyright-and-re-use/crown-copyright/">&copy; {{crownCopyrightMessage}}</a>
      </div>
    </div>
  </div>
</footer>
